export const endpoints = {
  GET_SOSREPORT: {
    url: "/api/sosreport",
  },
  GET_CANCEL_UPLOAD: {
    url: "/api/file/upload/cancel",
  },
  GET_PDF_SUMMARY: {
    url: "/api/sosreport/pdf-summary",
  },
  GET_EXCEL_SUMMARY: {
    url: "/api/sosreport/excel-summary",
  },
  GET_EXCEL: {
    url: "/api/sosreport/excel-list",
  },
  UPDATE_SOSREPORT: {
    url: "/api/sosreport",
  },
  GET_SOSREPORT_REPORT: {
    url: "/api/sosreport/reports",
  },
  REMOVE_SOSREPORT: {
    url: "/api/sosreport/remove",
  },
  GET_USER: {
    url: "/api/user",
  },
  UPDATE_USER: {
    url: "/api/user",
  },
  UPDATE_PASSWORD: {
    url: "/auth/updatePassword",
  },
  LOGIN: {
    url: "/auth/authenticate",
  },
  SIGNUP: {
    url: "/auth/signup",
  },
  GET_FILE_DOWNLOAD: {
    url: "/api/file/download",
  },
  GET_MULTIPLE_FILE_DOWNLOAD: {
    url: "/api/file/download/multiple",
  },
  GET_HTML_VIEW: {
    url: "/api/file/html-view",
  },
  FIND_USERNAME: {
    url: "/auth/findUsername",
  },
  FIND_PASSWORD: {
    url: "/auth/findPassword",
  },
  GET_USER_LIST: {
    url: "/api/user/list",
  },
  REMOVE_USER: {
    url: "/api/user/remove",
  },
  UPDATE_USER_PASSWORD: {
    url: "/auth/updateUserPassword",
  },
  GET_GROUP: {
    url: "/api/group",
  },
  GET_GROUP_LIST: {
    url: "/api/group/list",
  },
  CREATE_GROUP: {
    url: "/api/group",
  },
  UPDATE_GROUP: {
    url: "/api/group",
  },
  REMOVE_GROUP: {
    url: "/api/group/remove",
  },
  GET_LICENSE: {
    url: "/api/license",
  },
  GET_LICENSE_SERVER_ID: {
    url: "/api/license/server-id",
  },
  ACTIVATE_LICENSE: {
    url: "/api/license/activate",
  },
};

